module.exports = "pegasus_template/assets/web_template/web_template_logo.png";